import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Alert } from 'react-bootstrap';

const SliderForm = ({ show, onHide, onSubmit, editingSlider }) => {
  const [formData, setFormData] = useState({
    fileUrl: '',
    intervalSecond: 5000,
    pageCode: 'MainPage',
    pictureUrl: '',
    pictureBase64: '',
    url: '',
    indexOrder: 0
  });

  const [error, setError] = useState('');

  // Düzenleme modunda form verilerini doldur
  useEffect(() => {
    if (editingSlider) {
      setFormData({
        fileUrl: editingSlider.fileUrl || '',
        intervalSecond: editingSlider.intervalSecond || 5000,
        pageCode: editingSlider.pageCode || 'MainPage',
        pictureUrl: editingSlider.fileUrl || '',
        pictureBase64: '',
        url: editingSlider.url || '',
        indexOrder: editingSlider.indexOrder || 0
      });
    } else {
      setFormData({
        fileUrl: '',
        intervalSecond: 5000,
        pageCode: 'MainPage',
        pictureUrl: '',
        pictureBase64: '',
        url: '',
        indexOrder: 0
      });
    }
  }, [editingSlider]);

  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
  const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const validateFile = (file) => {
    if (!file) return 'Lütfen bir resim seçin.';
    if (!ALLOWED_TYPES.includes(file.type)) return 'Sadece JPEG, PNG ve WebP formatları desteklenir.';
    if (file.size > MAX_FILE_SIZE) return 'Dosya boyutu 5MB\'dan küçük olmalıdır.';
    return null;
  };


  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    setError('');
    
    if (file) {
      const validationError = validateFile(file);
      if (validationError) {
        setError(validationError);
        e.target.value = null;
        return;
      }

      console.log('Seçilen dosya:', {
        name: file.name,
        type: file.type,
        size: `${(file.size / 1024).toFixed(2)} KB`
      });

      try {
        // Dosyayı base64'e çevir (sıkıştırma olmadan)
        const reader = new FileReader();
        reader.onload = (event) => {
          const base64String = event.target.result.split(',')[1];
          const base64WithPrefix = `data:${file.type};base64,${base64String}`;
          
          setFormData(prev => ({
            ...prev,
            pictureBase64: base64WithPrefix,
            pictureUrl: file.name,
            fileUrl: file.name
          }));
        };
        reader.readAsDataURL(file);
      } catch (error) {
        console.error('Dosya okuma hatası:', error);
        setError('Dosya işlenirken bir hata oluştu. Lütfen tekrar deneyin.');
        e.target.value = null;
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Düzenleme modunda resim yüklemek zorunlu değil
    if (!editingSlider && !formData.pictureBase64) {
      setError('Lütfen bir resim seçin.');
      return;
    }

    const submitData = {
      ...formData
    };

    // Düzenleme modunda resim değişmemişse base64'i gönderme
    if (editingSlider && !formData.pictureBase64) {
      delete submitData.pictureBase64;
    }

    console.log('Form submit edilirken:', {
      formData: { ...formData, pictureBase64: formData.pictureBase64 ? '<<base64-data>>' : 'no-image' }
    });

    onSubmit(submitData);
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{editingSlider ? 'Slider Düzenle' : 'Yeni Slider Ekle'}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && (
            <Alert variant="danger" onClose={() => setError('')} dismissible>
              {error}
            </Alert>
          )}
          <Form.Group className="mb-3">
            <Form.Label>Resim</Form.Label>
            <Form.Control
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              required={!editingSlider}
            />
            {editingSlider && (
              <Form.Text className="text-muted">
                Mevcut resmi değiştirmek için yeni bir resim seçin
              </Form.Text>
            )}
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Gösterim Süresi (ms)</Form.Label>
            <Form.Control
              type="number"
              name="intervalSecond"
              value={formData.intervalSecond}
              onChange={handleChange}
              min="1000"
              step="1000"
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>URL (Görsel tıklandığında gidilecek URL)</Form.Label>
            <Form.Control
              type="url"
              name="url"
              value={formData.url}
              onChange={handleChange}
              placeholder="https://iskenderun.bel.tr"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Sıralama</Form.Label>
            <Form.Control
              type="number"
              name="indexOrder"
              value={formData.indexOrder}
              onChange={handleChange}
              min="0"
              placeholder="0"
            />
            <Form.Text className="text-muted">
              Slider'ın görüntülenme sırası (0 = ilk sırada)
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Sayfa Kodu</Form.Label>
            <Form.Control
              type="text"
              name="pageCode"
              value={formData.pageCode}
              onChange={handleChange}
              required
              disabled
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            İptal
          </Button>
          <Button variant="primary" type="submit">
            {editingSlider ? 'Güncelle' : 'Kaydet'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default SliderForm;
